(() => {
  const body = document.body;
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const toast = document.querySelector('[data-toast]');
  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };
  const setMenu = (open) => {
    body.classList.toggle('menu-open', open);
    menuToggle?.setAttribute('aria-expanded', String(open));
    mobileNav?.setAttribute('aria-hidden', String(!open));
  };
  menuToggle?.addEventListener('click', () => setMenu(!body.classList.contains('menu-open')));
  mobileNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity }) });
    if (!response.ok) throw new Error('Unable to add this item right now.');
    const cart = await fetch('/cart.js').then((result) => result.json());
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    showToast('Added to your comfort queue.');
  };
  document.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.variantId); } catch (error) { showToast(error.message); }
    button.disabled = false;
  }));
  document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    try { await addVariant(new FormData(form).get('id')); } catch (error) { showToast(error.message); }
    submit.disabled = false;
  }));

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries, current) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      current.unobserve(entry.target);
    }), { threshold: .12, rootMargin: '0px 0px -35px' });
    revealItems.forEach((item) => observer.observe(item));
  } else revealItems.forEach((item) => item.classList.add('is-visible'));

  const galleryMain = document.querySelector('[data-gallery-main]');
  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb, index) => {
    if (index === 0) thumb.classList.add('is-active');
    thumb.addEventListener('click', () => {
      if (!galleryMain) return;
      galleryMain.src = thumb.dataset.galleryThumb;
      galleryMain.alt = thumb.dataset.alt || galleryMain.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const companionAllowed = matchMedia('(pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (companionAllowed) {
    const companion = document.createElement('div');
    companion.className = 'cursor-companion';
    companion.setAttribute('aria-hidden', 'true');
    body.appendChild(companion);
    let targetX = -100, targetY = -100, currentX = -100, currentY = -100, previousX = -100, rotation = 0;
    document.addEventListener('pointermove', (event) => { targetX = event.clientX + 13; targetY = event.clientY + 14; companion.classList.add('is-visible'); }, { passive: true });
    document.addEventListener('pointerleave', () => companion.classList.remove('is-visible'));
    document.addEventListener('pointerover', (event) => companion.classList.toggle('is-hovering', Boolean(event.target.closest('a, button, input, select, summary, label'))));
    const animate = () => {
      currentX += (targetX - currentX) * .17; currentY += (targetY - currentY) * .17;
      const velocity = currentX - previousX; rotation += (Math.max(-12, Math.min(12, velocity * 1.6)) - rotation) * .2; previousX = currentX;
      companion.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) rotate(${rotation}deg)`;
      requestAnimationFrame(animate);
    };
    animate();
  }
})();
